import { EMPTY_LIST } from '../../../../../constants/common'
import { FORMIK_EMPTY_VALUE } from '../../../../../constants/validation'
import {
  NEWSBOARD_POST_AUDIENCE_TO_ALL_COLLEAGUES,
  NEWSBOARD_POST_AUDIENCE_TO_DIGITAL_BOARD,
  NEWSBOARD_POST_AUDIENCE_TO_NOT_SIGNED_UP_DWELLERS,
  NEWSBOARD_POST_AUDIENCE_TO_NOT_SIGNED_UP_LANDLORDS,
  NEWSBOARD_POST_AUDIENCE_TO_SIGNED_UP_DWELLERS,
  NEWSBOARD_POST_AUDIENCE_TO_SIGNED_UP_LANDLORDS,
} from '../../../Newsboard.constants'
import {
  ALL_BUILDING_GROUPS_COUNT,
  ALL_BUILDINGS_COUNT,
} from '../../NewsboardPostForm.constants'

export const USERS_ALL_VALUE = 'all'

export const REGISTERED_USERS_OPTIONS = [
  { label: 'Newsboard.AllRegisteredUsersKey', value: USERS_ALL_VALUE },
  {
    label: 'Newsboard.RegisteredLandlordsOnlyKey',
    value: NEWSBOARD_POST_AUDIENCE_TO_SIGNED_UP_LANDLORDS,
  },
  {
    label: 'Newsboard.RegisteredTenantsOnlyKey',
    value: NEWSBOARD_POST_AUDIENCE_TO_SIGNED_UP_DWELLERS,
  },
]

export const NON_REGISTERED_USERS_OPTIONS = [
  { label: 'Newsboard.AllNonRegisteredUsersKey', value: USERS_ALL_VALUE },
  {
    label: 'Newsboard.NonRegisteredLandlordsOnlyKey',
    value: NEWSBOARD_POST_AUDIENCE_TO_NOT_SIGNED_UP_LANDLORDS,
  },
  {
    label: 'Newsboard.NonRegisteredTenantsOnlyKey',
    value: NEWSBOARD_POST_AUDIENCE_TO_NOT_SIGNED_UP_DWELLERS,
  },
]

export const NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_REGISTERED_USERS_CHECKBOX =
  'registered'

export const NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_REGISTERED_USERS =
  'registered_users'

export const NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_STATUS = 'status'

export const NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_NON_REGISTERED_USERS_CHECKBOX =
  'non_registered'

export const NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_NON_REGISTERED_USERS =
  'non_registered_users'

export const NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_ADD_INFO_FIELDS =
  'info_fields'

export const NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_TV_SCREENS =
  NEWSBOARD_POST_AUDIENCE_TO_DIGITAL_BOARD

export const NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_ALL_EMPLOYEES =
  NEWSBOARD_POST_AUDIENCE_TO_ALL_COLLEAGUES

export const NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_RADIO_BUILDINGS =
  'buildings_or_building_groups'

export const NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_BUILDING = 'buildings'

export const NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_BUILDING_FLAT_TYPE =
  'flat_building'

export const NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_BUILDING_GROUP =
  'building_groups'

export const NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_BUILDING_GROUP_FLAT_TYPE =
  'flat_building_group'

export const NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_USER_INFO_STATUS =
  'user_info_status'

export const RecipientAudienceOptionValue = {
  Building: 'Building',
  BuildingGroups: 'BuildingGroups',
}

export const NEWSBOARD_POST_FORM_RECIPIENTS_INITIAL_VALUES = {
  [ALL_BUILDING_GROUPS_COUNT]: 0,
  [ALL_BUILDINGS_COUNT]: 0,
  [NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_ADD_INFO_FIELDS]:
    FORMIK_EMPTY_VALUE,
  [NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_ALL_EMPLOYEES]: false,
  [NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_BUILDING]: EMPTY_LIST,
  [NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_BUILDING_FLAT_TYPE]: EMPTY_LIST,
  [NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_BUILDING_GROUP]: EMPTY_LIST,
  [NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_BUILDING_GROUP_FLAT_TYPE]:
    EMPTY_LIST,
  [NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_NON_REGISTERED_USERS]:
    NON_REGISTERED_USERS_OPTIONS[0],
  [NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_NON_REGISTERED_USERS_CHECKBOX]: false,
  [NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_RADIO_BUILDINGS]:
    RecipientAudienceOptionValue.Building,
  [NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_REGISTERED_USERS]:
    REGISTERED_USERS_OPTIONS[0],
  [NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_REGISTERED_USERS_CHECKBOX]: false,
  [NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_STATUS]: FORMIK_EMPTY_VALUE,
  [NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_TV_SCREENS]: false,
  [NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_USER_INFO_STATUS]: EMPTY_LIST,
}

export const NEWSBOARD_POST_FORM_RECIPIENTS_CHECKBOX_SOME_REQUIRED_FIELDS = [
  NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_ALL_EMPLOYEES,
  NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_TV_SCREENS,
  NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_NON_REGISTERED_USERS_CHECKBOX,
  NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_REGISTERED_USERS_CHECKBOX,
]
